export default "__VITE_ASSET__DL59oFSl__"